// components/ui/InterpretationLine.tsx
// Italic serif pull-quote with a thin indigo left-rule.
// Sits between the title block and the verdict trio on the report.

import React from 'react';

interface InterpretationLineProps {
    children: React.ReactNode;
    maxWidth?: number;
}

export function InterpretationLine({ children, maxWidth = 640 }: InterpretationLineProps) {
    return (
        <div
            className="interpretation-line font-serif italic text-[17px] leading-relaxed text-[#1A1A1A]
                       pl-4 border-l-2 border-[#3730A3] mb-8"
            style={{ maxWidth }}
        >
            {children}
        </div>
    );
}
